import { useMemo } from 'react'

import { DiskInterfaceData } from '../hooks/useNodeMonitorData'
import { DualLineChart } from './DualLineChart'

const DISK_IO_LABELS = { primary: 'Read', secondary: 'Write' } as const

interface DiskIOChartProps {
  interfaces: DiskInterfaceData[]
  selectedDevices: string[]
  filterDuration: number
}

export function DiskIOChart({ interfaces, selectedDevices, filterDuration }: DiskIOChartProps) {
  const data = useMemo(
    () =>
      interfaces.map((i) => ({
        name: i.name,
        primaryValues: i.readValues,
        secondaryValues: i.writeValues,
        isEmpty: i.isEmpty,
      })),
    [interfaces],
  )

  return (
    <DualLineChart
      data={data}
      selectedItems={selectedDevices}
      labels={DISK_IO_LABELS}
      filterDuration={filterDuration}
    />
  )
}
